<template>
  <div class="account-edit-modal">
    <!-- 弹窗容器 -->
    <div class="account-edit-card">
      <!-- 标题栏 -->
      <div class="card-header">
        <h3 class="header-title">修改帐号密码</h3>
        <button class="close-btn" @click="quit" aria-label="关闭">
          <i class="el-icon-close"></i>
        </button>
      </div>

      <!-- 表单区域 -->
      <div class="form-container">
        <!-- 用户名输入 -->
        <div class="form-item">
          <label class="form-label" :class="{ 'label-error': error.name }">
            用户名
            <span class="required-mark">*</span>
          </label>
          <el-input
            v-model="name"
            type="text"
            placeholder="请输入新用户名"
            size="medium"
            class="form-input"
            @blur="validateName"
          />
          <p class="error-message" v-if="error.name">{{ error.name }}</p>
        </div>

        <!-- 原密码输入 -->
        <div class="form-item">
          <label class="form-label" :class="{ 'label-error': error.oldpass }">
            原密码
            <span class="required-mark">*</span>
          </label>
          <el-input
            v-model="oldpass"
            type="password"
            placeholder="请输入原密码"
            size="medium"
            class="form-input"
            @blur="validateOldPass"
          />
          <p class="error-message" v-if="error.oldpass">{{ error.oldpass }}</p>
        </div>

        <!-- 新密码输入 -->
        <div class="form-item">
          <label class="form-label" :class="{ 'label-error': error.newpass }">
            新密码
            <span class="required-mark">*</span>
          </label>
          <el-input
            v-model="newpass"
            type="password"
            placeholder="请输入8-20位新密码（含字母+数字）"
            size="medium"
            class="form-input"
            @blur="validateNewPass"
          />
          <p class="error-message" v-if="error.newpass">{{ error.newpass }}</p>
          <p class="password-hint">
            <i class="el-icon-info"></i> 密码需包含字母和数字，长度8-20位
          </p>
        </div>

        <!-- 确认新密码输入 -->
        <div class="form-item">
          <label
            class="form-label"
            :class="{ 'label-error': error.confirmPass }"
          >
            确认新密码
            <span class="required-mark">*</span>
          </label>
          <el-input
            v-model="confirmPass"
            type="password"
            placeholder="请再次输入新密码"
            size="medium"
            class="form-input"
            @blur="validateConfirmPass"
          />
          <p class="error-message" v-if="error.confirmPass">
            {{ error.confirmPass }}
          </p>
        </div>
      </div>

      <!-- 按钮区域 -->
      <div class="button-group">
        <el-button
          type="primary"
          size="medium"
          class="submit-btn"
          @click="handleSubmit"
          :loading="submitLoading"
        >
          确认修改
        </el-button>
        <el-button
          type="default"
          size="medium"
          class="cancel-btn"
          @click="quit"
        >
          取消
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Setitem, Getitem } from "@/utils/item.js";
import { editpassword, login } from "../../utils/request.js";

export default {
  name: "Gedituser",
  data() {
    return {
      // 表单数据
      name: "", // 新用户名
      oldpass: "", // 原密码
      newpass: "", // 新密码
      confirmPass: "", // 确认新密码
      // 状态控制
      error: {
        name: "",
        oldpass: "",
        newpass: "",
        confirmPass: "",
      },
      submitLoading: false, // 提交加载状态
      userInfo: {}, // 当前用户信息
    };
  },
  created() {
    this.name = Getitem("name") || "";
  },
  methods: {
    // 关闭弹窗
    quit() {
      this.$emit("close");
      // 重置表单
      this.resetForm();
    },

    // 重置表单
    resetForm() {
      this.oldpass = "";
      this.newpass = "";
      this.confirmPass = "";
      this.error = {
        name: "",
        oldpass: "",
        newpass: "",
        confirmPass: "",
      };
      this.submitLoading = false;
    },

    // 表单验证 - 用户名
    validateName() {
      if (!this.name.trim()) {
        this.error.name = "用户名不能为空";
        return false;
      }
      if (this.name.trim().length < 2) {
        this.error.name = "用户名不能少于2个字符";
        return false;
      }
      this.error.name = "";
      return true;
    },

    // 表单验证 - 原密码
    validateOldPass() {
      if (!this.oldpass) {
        this.error.oldpass = "原密码不能为空";
        return false;
      }
      this.error.oldpass = "";
      return true;
    },

    // 表单验证 - 新密码（复杂度校验）
    validateNewPass() {
      const pass = this.newpass;
      if (!pass) {
        this.error.newpass = "新密码不能为空";
        return false;
      }
      if (pass.length < 8 || pass.length > 20) {
        this.error.newpass = "新密码必须在8-20个字符之间";
        return false;
      }
      // 校验：包含字母+数字
      const hasLetter = /[a-zA-Z]/.test(pass);
      const hasNumber = /\d/.test(pass);
      if (!hasLetter || !hasNumber) {
        this.error.newpass = "新密码需同时包含字母和数字";
        return false;
      }
      this.error.newpass = "";
      return true;
    },

    // 表单验证 - 确认新密码（一致性校验）
    validateConfirmPass() {
      if (!this.confirmPass) {
        this.error.confirmPass = "请确认新密码";
        return false;
      }
      if (this.confirmPass !== this.newpass) {
        this.error.confirmPass = "两次输入的新密码不一致";
        return false;
      }
      this.error.confirmPass = "";
      return true;
    },

    // 全量表单验证
    validateForm() {
      const validName = this.validateName();
      const validOldPass = this.validateOldPass();
      const validNewPass = this.validateNewPass();
      const validConfirmPass = this.validateConfirmPass();
      return validName && validOldPass && validNewPass && validConfirmPass;
    },

    // 提交修改
    async handleSubmit() {
      // 1. 表单基础验证
      if (!this.validateForm()) return;

      this.submitLoading = true;
      try {
        const updateData = {
          cusUserId: Getitem("userid"),
          username: this.name,
          passwordOld: this.oldpass,
          password: this.newpass,
        };

        // 4. 调用修改接口
        const updateRes = await editpassword(updateData);
        if (updateRes.code === 200) {
          this.$toast.success("帐号密码修改成功！");
          Setitem("name", this.name.trim());
          this.$store.commit("setusername", this.name.trim());
          this.$emit("close");
        } else {
          this.$toast.error(updateRes.msg || "修改失败，请重试");
        }
      } catch (err) {
        // console.error("修改失败：", err);
        this.$toast.error("网络异常，请检查网络连接");
      } finally {
        this.submitLoading = false;
      }
    },
  },
};
</script>

<style scoped lang="less">
// 弹窗背景层
.account-edit-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

// 表单卡片
.account-edit-card {
  width: 100%;
  max-width: 350px;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 6px 25px rgba(0, 0, 0, 0.2);
  }
}

// 标题栏
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid #f5f5f5;

  .header-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin: 0;
  }

  .close-btn {
    background: transparent;
    border: none;
    font-size: 18px;
    color: #999;
    cursor: pointer;
    transition: color 0.2s ease;

    &:hover {
      color: #666;
    }
  }
}

// 表单容器
.form-container {
  padding: 24px;
}

// 表单项
.form-item {
  margin-bottom: 20px;
  position: relative;

  // 标签
  .form-label {
    display: block;
    margin-bottom: 8px;
    font-size: 14px;
    color: #666;
    transition: color 0.2s ease;
    text-align: left;

    .required-mark {
      color: #ff4d4f;
      margin-left: 4px;
    }
  }

  // 错误标签样式
  .label-error {
    color: #ff4d4f;
  }

  // 输入框
  .form-input {
    width: 100%;
    border-radius: 6px;
    border-color: #dcdfe6;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;

    &:focus {
      border-color: #409eff;
      box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
    }
  }

  // 错误提示
  .error-message {
    margin: 4px 0 0 0;
    font-size: 12px;
    color: #ff4d4f;
    height: 16px;
    line-height: 16px;
  }

  // 密码提示
  .password-hint {
    margin: 4px 0 0 0;
    font-size: 12px;
    color: #999;
    display: flex;
    align-items: center;

    .el-icon-info {
      margin-right: 4px;
      font-size: 12px;
    }
  }
}

// 按钮组
.button-group {
  display: flex;
  justify-content: center;
  gap: 12px;
  padding: 0 24px 24px;

  .submit-btn {
    width: 120px;
    border-radius: 6px;
    background-color: #409eff;
    border-color: #409eff;

    &:hover {
      background-color: #66b1ff;
      border-color: #66b1ff;
    }
  }

  .cancel-btn {
    width: 120px;
    border-radius: 6px;
    border-color: #dcdfe6;

    &:hover {
      border-color: #c0c4cc;
      background-color: #f5f7fa;
    }
  }
}

// 响应式适配（移动端）
@media (max-width: 768px) {
  .account-edit-card {
    max-width: 100%;
  }

  .button-group {
    justify-content: center;
    flex-wrap: wrap;

    .submit-btn,
    .cancel-btn {
      width: 45%;
    }
  }
}
</style>
